import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import ContactPage from './ContactPage';

export const mapStateToProps = (state: AppState) => {
    return {

    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {

    };
};

const ContactPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ContactPage);

export default ContactPageContainer;



// WEBPACK FOOTER //
// ./src/components/contactus/ContactContainer.tsx